import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

export default function Detail_2({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  const GetScaleText = () => {
    const ranges = item.scale.ranges;
    for (let index = 0; index < ranges.length; index++) {
      const range = ranges[index];
      if (range.isHit) {
        if (item.scale.isHtml) {
          return <div className="flex-center" dangerouslySetInnerHTML={{ __html: range.text }} />;
        } else {
          return <p className="_detail-2-scale-text flex-center mb-0">{range.text}</p>;
        }
      }
    }
  };

  return (
    <Row className="mb-3 mx-0">
      <Col md="4" xs="12">
        <div className="detail-scale-text-wrap-up" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
      </Col>
      <Col md="4" xs="12">
        <Row className={"justify-content-center"}>
          <Col
            xs={"auto"}
            className={"  " + (isSub ? "_detail-2-sub-scope-name-header" : "_detail-2-scope-name-header")}
          >
            {" "}
            {item.name}
          </Col>
          <Col xs={"auto"} className={"align-content-center ps-0"}>
            <div className={isSub ? "_detail-2-sub-scope-score-header" : "_detail-2-scope-score-header"}>
              {elementScore}
            </div>
          </Col>
        </Row>
        <br />
        <Row className={"mb-2"}> {GetScaleText()}</Row>
        <ProgressBar variant={isSub ? "sub-scope" : "main-scope"} now={elementScore} label={`${elementScore}%`} />
      </Col>
      <Col md="4" xs="12">
        <div className="detail-scale-text-wrap-up  text-end" dangerouslySetInnerHTML={{ __html: item.highSideText }} />
      </Col>
    </Row>
  );
}
